import React, { forwardRef, useEffect, useState } from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const BrochurePagination = forwardRef(({propertyName}, ref) => {
    const [ pageNumber, setPageNumber ] = useState(1);

    useEffect(() => {
        if (!ref?.current) {
            return null;
        }
        const allElements = document.getElementsByClassName('print-page');
        for (var i = 0; i < allElements.length; i++) {
            if (allElements[i] === ref.current) {
                setPageNumber(i + 1);
                break;
            }
        }
    }, [ref]);
    return (
        <div className='flex absolute bottom-0 mb6 print-container'>
            <div className='print-col-1'>
                <p className='print-type-8px'>Russell Simpson</p>
            </div>
            <div className='print-col-1' />
            <div className='print-col-1'>
                <p className='print-type-8px'>
                    {propertyName}
                </p>
            </div>
            <div className='print-col-4' />
            <div className='print-col-1 flex justify-end'>
                <p className='print-type-8px'>
                    {pageNumber}
                </p>
            </div>
        </div>
    );
});

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

BrochurePagination.displayName = 'HeaderNavigation';

export default BrochurePagination;
